<grid-engine-grid-page
  [masterDetailEnabled]="masterDetailEnabled()"
  [masterDetailCellRenderer]="masterDetailCellRenderer()"
  [masterDetailRowAutoHeight]="masterDetailRowAutoHeight()"
  (dispatchGridEvent)="onDispatchGridEvent($event)"
  (dispatchMasterViewEngineEvent)="onDispatchMasterViewEngineEvent($event)"
  (pageChange)="onPageChange($event)"
  (rowClicked)="onClickRow($event)"
  (rowSelected)="onSelectRow($event)"
  (sortChange)="onSortChange($event)"
  [autoScroll]="autoScroll()"
  [gridSort]="gridSort()"
  [grid]="grid()"
  [hidePaginator]="hidePaginator()"
  [loading]="computedLoading()"
  [userPermissions]="userPermissions()"
  [visibleNodeId]="visibleNodeId()"
/>
